export class SearchOperationsProposalQueryModel {
  startDate: string;
  endDate: string;
  institution: string;
  serviceContract: string;
  cpfCnpj: string;
  operationStatus: string;
  onlyPendingOperationStatus: boolean;
  technologyGroup: string;
  logicNumber: string;
}
